export default __webpack_public_path__ + "static/bg-hero-bottom-290e27a85252b9a525a7a329ffd3df6c.png";